import { render, staticRenderFns } from "./noteDelete.vue?vue&type=template&id=8497ec72&scoped=true&"
import script from "./noteDelete.vue?vue&type=script&lang=js&"
export * from "./noteDelete.vue?vue&type=script&lang=js&"
import style0 from "./noteDelete.vue?vue&type=style&index=0&id=8497ec72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8497ec72",
  null
  
)

export default component.exports